"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GiftCardIcon = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GiftCardIcon = function GiftCardIcon(_ref) {
  var rest = Object.assign({}, _ref);

  var svgProps = _objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2em",
    height: "2em",
    viewBox: "0 0 28 22",
    fill: "none"
  }, rest);

  return _react.default.createElement("svg", svgProps, _react.default.createElement("path", {
    d: "M11.2315 6.22926C10.5275 6.93317 8.49353 7.36508 8.49353 7.36508C8.49353 7.36508 9.00465 5.25335 9.62935 4.62716C10.0717 4.18479 10.7891 4.18479 11.23 4.62716C11.6708 5.06953 11.6723 5.78689 11.23 6.22777L11.2315 6.22926Z",
    stroke: "white",
    strokeMiterlimit: "10"
  }), _react.default.createElement("path", {
    d: "M8.49349 7.36505L5.30273 10.5558",
    stroke: "white",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), _react.default.createElement("path", {
    d: "M6.64921 4.62715C7.35312 5.33106 7.78503 7.36507 7.78503 7.36507C7.78503 7.36507 5.67331 6.85395 5.04711 6.22925C4.60474 5.78688 4.60474 5.06952 5.04711 4.62864C5.48948 4.18777 6.20684 4.18627 6.64772 4.62864L6.64921 4.62715Z",
    stroke: "white",
    strokeMiterlimit: "10"
  }), _react.default.createElement("path", {
    d: "M7.78503 7.36505L10.9758 10.5558",
    stroke: "white",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), _react.default.createElement("path", {
    d: "M8.13477 1.44833V15.8269",
    stroke: "white",
    strokeMiterlimit: "10"
  }), _react.default.createElement("path", {
    d: "M1.44836 7.71628H22.4087",
    stroke: "white",
    strokeMiterlimit: "10"
  }), _react.default.createElement("path", {
    d: "M14.2756 13.2907H19.5677",
    stroke: "white",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), _react.default.createElement("path", {
    d: "M20.4165 1.44833H3.44053C2.34029 1.44833 1.44836 2.34026 1.44836 3.4405V13.8347C1.44836 14.935 2.34029 15.8269 3.44053 15.8269H20.4165C21.5168 15.8269 22.4087 14.935 22.4087 13.8347V3.4405C22.4087 2.34026 21.5168 1.44833 20.4165 1.44833Z",
    stroke: "white",
    strokeMiterlimit: "10"
  }), _react.default.createElement("path", {
    d: "M22.7838 3.81564C23.8838 3.81564 24.776 4.70786 24.776 5.80781V16.202C24.776 17.302 23.8838 18.1942 22.7838 18.1942H5.8093C4.70935 18.1942 3.81714 17.302 3.81714 16.202",
    stroke: "white",
    strokeMiterlimit: "10"
  }), _react.default.createElement("path", {
    d: "M25.1796 6.2113C26.2795 6.2113 27.1717 7.10352 27.1717 8.20347V18.5977C27.1717 19.6977 26.2795 20.5899 25.1796 20.5899H8.20506C7.10511 20.5899 6.21289 19.6977 6.21289 18.5977",
    stroke: "white",
    strokeMiterlimit: "10"
  }));
};

exports.GiftCardIcon = GiftCardIcon;